import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Domain } from '@ragu-components/ord-types';

const DomainsList = React.lazy(async () => import('./DomainsList'));

export const domainsResources: OrdResourceProps = {
  key: Resources.domains,
  name: Resources.domains,
  list: <DomainsList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: Domain) => record.organization,
};
